<template>
  <div class="text-left">
    <div>
      <b-form @submit.prevent="submit">
        <div v-if="false">
          <div v-if="model.passportCopy">
            <img :src="previewPassportCopy" alt="" />
          </div>
          <input type="file" @change="onChange_PassportCopy" />
        </div>
        <div class="mb-5 text-center ">
          <h5 class="my-4">Are you an existing student?</h5>
          <b-form-group class="mb-3" id="input-group-2" label-for="input-2">
            <b-form-checkbox
              v-model="model.existingStudent"
              name="check-button"
              switch
            >
              <span
                v-if="model.existingStudent"
                class="bg-warning text-dark pt-1 pb-2 px-5 font-weight-bold rounded"
                >No</span
              ><span
                v-else
                class="bg-info text-white pt-1 pb-2 px-5 font-weight-bold rounded"
                >Yes</span
              >
            </b-form-checkbox>
          </b-form-group>
        </div>
        <div v-if="model.existingStudent">
          <div class="row">
            <div class="col-md-6">
              <b-form-group
                id="input-group-1"
                :label="`Student ID:`"
                label-for="input-1"
              >
                <b-form-input
                  v-model="model.applicant.studentCode"
                  :id="`input-1`"
                  :type="`text`"
                ></b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-6">
              <b-form-group
                id="input-group-2"
                :label="`Full name:`"
                label-for="input-2"
              >
                <b-form-input
                  v-model="model.applicant.fullName"
                  :id="`input-2`"
                  :type="`text`"
                ></b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-6">
              <b-form-group
                id="input-group-3"
                :label="`Email address:`"
                label-for="input-3"
              >
                <b-form-input
                  v-model="model.applicant.emailAddress"
                  :id="`input-3`"
                  :type="`email`"
                ></b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-6">
              <b-form-group
                id="input-group-4"
                :label="`Birth date:`"
                label-for="input-4"
              >
                <b-form-input
                  v-model="model.applicant.birthDate"
                  :id="`input-4`"
                  :type="`date`"
                ></b-form-input>
              </b-form-group>
            </div>
          </div>
          <hr />
        </div>
        <hr />
        <div class="my-3">
          <div class="row">
            <div class="col-6">
              <h3 v-if="getBooking && false" id="calculatedPrice">
                Total: &euro;{{ getTotalAmount | round }}
              </h3>
            </div>
            <div class="col text-right">
              <b-button
                v-if="getBooking.step > getBooking.firstStep"
                type="button"
                variant="default"
                @click="back()"
                >Back</b-button
              >
              <b-button type="submit" variant="primary">Next</b-button>
            </div>
          </div>
        </div>
      </b-form>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import "../../filters";

export default {
  name: "BookingStudent",
  props: {
    bookingType: {
      type: String,
      default: process.env.VUE_APP_BOOKING_TYPE
        ? process.env.VUE_APP_BOOKING_TYPE
        : "",
    },
  },
  data() {
    return {
      loading: false,
      model: null,
      previewPassportCopy: null,
    };
  },
  computed: {
    ...mapGetters(["getBooking"]),
    getTotalAmount() {
      if (this.model.package) {
        return this.model.euApplicant
          ? this.model.package.eu_price
          : this.model.package.regular_price;
      }
      return 0;
    },
  },
  methods: {
    ...mapActions([
      "saveBooking",
      "findStudent",
      "moveBookingBack",
      "moveBookingNext",
    ]),
    async save() {
      let vm = this;

      if (vm.model.existingStudent) {
        vm.$swal({
          text: "Please wait...",
          icon: "info",
          closeOnClickOutside: false,
          button: false,
        });

        await vm.findStudent(vm.model);
        vm.$swal.close();

        if (vm.model.exception) {
          vm.$swal({
            title: "Error",
            text: vm.model.exception.message,
            icon: "error",
          });
        } else if (
          !vm.getBooking.person ||
          vm.getBooking.person.student_id == ""
        ) {
          vm.$swal({
            title: "Error",
            text: "Sorry! There is no information found with given inputs.",
            icon: "error",
          });
        }
      } else {
        vm.saveBooking(vm.model);
      }

      vm.next();
    },
    submit() {
      let vm = this;

      if (vm.model.existingStudent) {
        if (
          vm.model.applicant.studentCode === "" &&
          vm.model.applicant.fullName === "" &&
          vm.model.applicant.emailAddress === ""
        ) {
          vm.$swal("Please input either ID or Name or Email");
          return false;
        }

        if (vm.model.applicant.birthDate === "") {
          vm.$swal("Please input birth date");
          return false;
        }
      }

      // finally call save
      vm.save();
    },
    back() {
      // go back
      //const thisStep = this.model.step ? this.model.step : 1;
      //if (thisStep > 1) this.model.step = thisStep - 1;
      this.saveBooking(this.model);
      this.moveBookingBack();
      return false;
    },
    next() {
      // go to next
      //const thisStep = this.model.step ? this.model.step : 1;
      //if (thisStep > 0) this.model.step = thisStep + 1;

      //this.saveBooking(this.model);
      this.moveBookingNext();
      return false;
    },

    onChange_PassportCopy(e) {
      let vm = this;
      let files = e.target.files || e.dataTransfer.files;
      vm.model.passportCopy = files[0];
      vm.renderPreview("passportCopy");
    },
    renderPreview(name) {
      let vm = this;
      let reader = new FileReader();
      reader.onload = (e) => {
        if (name === "passportCopy") vm.previewPassportCopy = e.target.result;
      };

      let file = null;
      if (name === "passportCopy") file = vm.model.passportCopy;

      if (file) reader.readAsDataURL(file);
    },
  },
  created() {
    let vm = this;
    if (vm.getBooking) {
      vm.model = JSON.parse(JSON.stringify(vm.getBooking));
    }

    if (vm.model && !vm.model.euApplicant) {
      vm.model.euApplicant = false;
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
